module.exports = __webpack_public_path__ + "static/media/SFX_CoinWithBell_Terminator_1a.81fb43ce.mp3";